import { type AxiosRequestConfig, type SerializerVisitor } from 'axios';
// eslint-disable-next-line no-restricted-imports -- this an exception for axios import
import axios from 'axios';
import { isArray } from 'lodash';
import qs from 'qs';

import { isMobileApp } from 'hb-react/shared/utils/mobile';
import getCsrfToken from 'helpers/getCsrfToken';

import { configToSnakeCase, responseToCamelCase } from './axiosInterceptors';

const baseConfig: AxiosRequestConfig = {
  withCredentials: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-Token': getCsrfToken(),
    ...(isMobileApp() && {
      'X-Hivebrite-Mobile-App': isMobileApp().toString(),
    }),
  },
  paramsSerializer: (params: unknown) =>
    qs.stringify(params, { arrayFormat: 'brackets' }),
};

// Axios defaultVisitor handle arrays correctly only they they are at root level,
// other will be serialized with the index inside the brackets
// ie: { foo: { bar: ['baz'] } } => foo[bar][0]=baz instead of foo[bar][]=baz
//
// This visitor fix this issue by serializing arrays at any level.
export const formSerializerVisitor: SerializerVisitor = function (
  this,
  value,
  key,
  path,
  helpers,
) {
  if (isArray(value) && !value.some(helpers.isVisitable)) {
    value.forEach((el) => {
      const newKey = [...(path || []), key]
        .map((segment, index) => (!index ? segment : `[${segment}]`))
        .join('');
      this.append(`${newKey}[]`, helpers.convertValue(el));
    });
    return false;
  }
  return helpers.defaultVisitor.call(this, value, key, path, helpers);
};

export const axiosInstance = axios.create(baseConfig);

export const { isCancel, isAxiosError } = axios;

export const axiosWithSyntaxHandlers = axios.create(baseConfig);

axiosWithSyntaxHandlers.interceptors.request.use((config) =>
  configToSnakeCase(config),
);

axiosWithSyntaxHandlers.interceptors.response.use((response) =>
  responseToCamelCase(response),
);
